import * as RadixPopover from "@radix-ui/react-popover";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface PopoverProps {
  ariaLabel: string;
  trigger: React.ReactNode;
  children: React.ReactNode;
  closeButtonContent?: React.ReactNode;
  onClose?: () => void;
}

export function Popover({
  ariaLabel,
  trigger,
  closeButtonContent,
  children,
  onClose = () => null,
}: PopoverProps) {
  const { t } = useTranslation();

  return (
    <RadixPopover.Root
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <RadixPopover.Trigger asChild>{trigger}</RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content
          aria-label={ariaLabel}
          className="bg-page p-4 rounded-lg relative shadow-2xl z-[1000]"
          sideOffset={5}
        >
          {children}
          {closeButtonContent && (
            <RadixPopover.Close
              className={classNames(
                "absolute top-4 right-4 rounded-full w-6 h-6 flex items-center justify-center",
                "focus:outline-none focus:ring-2",
              )}
              aria-label={t("close")}
            >
              {closeButtonContent}
            </RadixPopover.Close>
          )}
          <RadixPopover.Arrow className="fill-current text-on-primary" />
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
}
